import React from 'react'
import {withProps} from 'recompose'
import {Node} from 'slate'
import {toBase64} from '../functions'
import {ElementTypes} from '../types'

const HeadingElement = ({
  style,
  element,
  children,
  className,
  attributes,
  Component = 'h1',
}) => {
  const text = Node.string(element)
  return (
    <Component
      {...attributes}
      style={style}
      className={className}
      id={toBase64(text)}>
      {children}
    </Component>
  )
}

export const HeadingOneElement = withProps({
  Component: 'h2',
  className: 'text-3xl md:text-4xl mt-12 mb-4 font-bold text-color-000 pl-3',
})(HeadingElement)

export const HeadingTwoElement = withProps({
  Component: 'h3',
  className: 'text-2xl font-semibold mt-12 mb-4 pl-4 text-color-000',
})(HeadingElement)

export const HeadingThreeElement = withProps({
  Component: 'h4',
  className: 'text-xl font-medium mt-8 mb-2 text-color-100',
})(HeadingElement)

export const headings = [
  ElementTypes.HEADING_ONE,
  ElementTypes.HEADING_TWO,
  ElementTypes.HEADING_THREE,
]

export default HeadingElement
